import { IGetCustomerParams } from 'apis/CustomerApis';
import {
  IGetCustomerByBranchId,
  ISearchCustomerInRoute,
  ISearchCustomerInSalePlanning,
  ISearchCustomerInTeamSale,
} from 'interfaces/Customer';

export interface IGetCustomerCb {
  value?: string;
  pageSize: number;
}

export const CUSTOMER_VARIABLE = {
  getCustomers: (params: IGetCustomerParams) => {
    const { pageSize, value } = params;
    return {
      skip: 0,
      take: pageSize || 10,
      input: {
        ...(value && {
          OR: [
            {
              id: {
                contains: value,
              },
            },
            {
              sapCustomerId: {
                contains: value,
              },
            },
            {
              storeName: {
                contains: value,
              },
            },
            {
              taxId: {
                contains: value,
              },
            },
          ],
        }),
      },
    };
  },
  getCustomerById: (params: any) => {
    // const { id } = params;
    return {
      input: {
        salesPlanningId: {
          equals: params,
        },
        useYn: {
          equals: true,
        },
      },
    };
  },

  deleteCustomerById: (params: any) => {
    const { id } = params;
    return {
      input: {
        id: id,
        useYn: false,
      },
    };
  },

  getUserRecommend: (param: any) => {
    const { id } = param;
    return {
      input: {
        tsalesPlanningCusts: {
          salesPlanningId: {
            not: `${id}`,
          },
        },
      },
    };
  },

  getNewCustomerByArea: (param: any) => {
    const { id } = param;
    return {
      input: {
        tsalesPlanningCusts: {
          salesPlanningId: {
            not: `${id}`,
          },
        },
        syncStatusId: {
          equals: 'A101_01',
        },
      },
    };
  },

  getCustomerByBranchId: (param: IGetCustomerByBranchId) => {
    const { salesPlanningId, customerId, customerName } = param;

    return {
      input: {
        useYn: {
          equals: true,
        },
        salesPlanningId: { equals: salesPlanningId },
        OR: [
          {
            customer: { id: { contains: customerId ?? '' } },
          },
          {
            customer: { storeName: { contains: customerName ?? '' } },
          },
          { customer: { sapCustomerId: { contains: customerId ?? '' } } },
        ],
      },
    };
  },
  createCustomer: (params: any) => {
    const {
      DanhXung,
      Gender,
      Surname,
      IDCusParent,
      address,
      birthday,
      cccd,
      city,
      cityNewId,
      coordinatesX,
      coordinatesY,
      district,
      email,
      nameCustomer,
      sdt,
      taxCode,
      typeCustomer,
      nameIndividualContact,
      ward,
      wardNewId,
      nameShort,
      urlImage1,
      urlImage2,
      urlImage3,
      urlImage4,
      urlImage5,
      urlImage6,
      urlImage7,
      urlImage8,
      urlImage9,
      urlImage10,
      note,
      LineBusiness,
      name,
      passportId,
      terrorismType,
      terrorismUserApproval,
      terrorismUserDate,
      terrorismUserPlant,
    } = params;

    return {
      data: {
        approvalYn: false,
        // approvalYn: true,
        // ...(nameShort && { shortName: nameShort.trim() }),
        // ...(nameIndividualContact && { name: nameIndividualContact.trim() }),
        ...(typeCustomer && {
          typeSap: typeCustomer === 'Cá nhân' ? '1' : '2',
        }),
        ...(DanhXung && {
          titleSap:
            DanhXung === 'Nam' ? '0002' : DanhXung === 'Nữ' ? '0001' : '0003',
        }),
        ...(Surname && { firstName: Surname.trim() }),
        ...(nameShort && { shortName: nameShort.trim() }),
        storeName:
          typeCustomer === 'Cá nhân'
            ? Surname.trim() + ' ' + name?.trim()
            : nameCustomer.trim(),
        ...(name && { name: name.trim() }),
        // storeName:
        //   typeCustomer === 'Cá nhân'
        //     ? Surname.trim() + ' ' + name.trim()
        //     : nameCustomer.trim(),
        // ...(nameCustomer && { storeName: nameCustomer }),
        ...(IDCusParent && { mainCustomerId: IDCusParent }),
        ...(taxCode && { taxId: taxCode.trim() }),
        ...(cccd && { cccd: cccd.trim() }),
        ...(passportId && { passportId: passportId.trim() }),
        ...(sdt && { phone: sdt.trim() }),
        ...(email && { email: email.trim() }),
        ...(Gender && { gender: Gender }),
        ...(birthday && { dayofbirth: birthday }),
        ...(address && {
          address:
            address.trim().charAt(0).toUpperCase() + address.trim().slice(1),
        }),
        ...(ward && { wardId: ward }),
        ...(wardNewId ? { wardNewId } : ward ? { wardNewId: ward } : {}),
        ...(district && { districtId: district }),
        ...(city && { cityId: city }),
        ...(cityNewId ? { cityNewId } : city ? { cityNewId: city } : {}),
        ...(coordinatesY && { longitude: coordinatesY }),
        ...(coordinatesX && { latitude: coordinatesX }),
        ...(urlImage1 && { urlImage1: urlImage1 }),
        ...(urlImage2 && { urlImage2: urlImage2 }),
        ...(urlImage3 && { urlImage3: urlImage3 }),
        ...(urlImage4 && { urlImage4: urlImage4 }),
        ...(urlImage5 && { urlImage5: urlImage5 }),
        ...(urlImage6 && { urlImage6: urlImage6 }),
        ...(urlImage7 && { urlImage7: urlImage7 }),
        ...(urlImage8 && { urlImage8: urlImage8 }),
        ...(urlImage9 && { urlImage9: urlImage9 }),
        ...(urlImage10 && { urlImage10: urlImage10 }),
        ...(note && { note: note.trim() }),
        ...(terrorismType !== undefined && { terrorismType }),
        ...(terrorismUserApproval && { terrorismUserApproval }),
        ...(terrorismUserDate && { terrorismUserDate }),
        ...(terrorismUserPlant && { terrorismUserPlant }),
        status: 'A100_01',
      },
    };
  },
  CreateCustomerPlant: (params: any) => {
    const { customerId, plantId } = params;
    return {
      input: {
        customerId: customerId,
        plantId: plantId,
      },
    };
  },
  CreateCustomerLineProduct: (params: any) => {
    const { customerId, LineBusiness, noteLineBusiness } = params;
    return {
      input: LineBusiness.map((item: any) => ({
        customerId: customerId,
        lineProductId: item,
        ...(item == 'K' &&
          noteLineBusiness && { note: noteLineBusiness.trim() }),
      })),
    };
  },
  deleteCustomerLineProduct: (params: any) => {
    return {
      input: {
        id: params,
      },
    };
  },
  GetCustomerInPlantComBoBox: (params: any) => {
    const { plantId, value, pageSize, typeCust, currentCust } = params;
    return {
      skip: 0,
      take: pageSize || 10,
      input: {
        ...(plantId && { plantId: plantId }),
        ...(value && { keySearch: value }),
        ...(typeCust && { typeCust: typeCust }),
        ...(currentCust && { currentCust: currentCust }),
      },
    };
  },
  CheckDuplicateTaxId: (taxId: any) => {
    return {
      input: {
        taxId: {
          equals: taxId,
        },
      },
    };
  },
  checkDuplicateCCCD: (value: string) => {
    return {
      input: {
        cccd: {
          equals: value,
        },
        typeSap: {
          equals: '1',
        },
      },
    };
  },
  checkMainCustomer: (mainCustomerId: string) => {
    return {
      input: {
        mainCustomerId: {
          equals: mainCustomerId,
        },
      },
    };
  },
  checkUserInfo: (id: string) => {
    return {
      input: {
        custId: id,
      },
    };
  },
  searchCustomerInRoute: ({ routeId, searchValue }: ISearchCustomerInRoute) => {
    return {
      input: {
        routeId: {
          equals: routeId,
        },
        customer: {
          OR: [
            {
              taxId: {
                equals: searchValue,
              },
            },
            {
              id: {
                equals: searchValue,
              },
            },
            {
              sapCustomerId: {
                equals: searchValue,
              },
            },
          ],
        },
      },
    };
  },
  searchCustomerInTeamSale: ({
    searchValue,
    teamSalesId,
  }: ISearchCustomerInTeamSale) => {
    return {
      input: {
        teamSalesId: { equals: teamSalesId },
        tcustomer: {
          OR: [
            { id: { equals: searchValue } },
            { taxId: { equals: searchValue } },
            { sapCustomerId: { equals: searchValue } },
          ],
        },
      },
    };
  },
  searchCustomerInSalePlanning: ({
    salesPlanningId,
    searchValue,
  }: ISearchCustomerInSalePlanning) => {
    return {
      input: {
        salesPlanningId: { equals: salesPlanningId },
        customer: {
          OR: [
            {
              taxId: { equals: searchValue },
            },
            {
              id: { equals: searchValue },
            },
            {
              sapCustomerId: { equals: searchValue },
            },
          ],
        },
      },
    };
  },
};

export const VARIABLE_GET_CUSTOMER = (params: any) => {
  const {
    id,
    mainCustomer,
    storeName,
    trank,
    wardId,
    districtId,
    cityId,
    cityNewId,
    wardNewId,
    status,
    plantId,
    page,
    page_size,
    cccd,
    phone,
    taxId,
    sapCustomerId,
  } = params;

  // const conditions = [
  //   ...(mainCustomer
  //     ? [{ customer: { mainCustomerId: { contains: mainCustomer.trim() } } }]
  //     : []),
  //   ...(sapCustomerId
  //     ? [{ customer: { sapCustomerId: { contains: sapCustomerId.trim() } } }]
  //     : []),
  //   ...(id ? [{ customer: { id: { contains: id.trim() } } }] : []),
  //   ...(storeName
  //     ? [{ customer: { storeName: { contains: storeName.trim() } } }]
  //     : []),
  //   ...(cccd ? [{ customer: { cccd: { contains: cccd.trim() } } }] : []),
  //   ...(phone ? [{ customer: { phone: { contains: phone.trim() } } }] : []),
  //   ...(taxId ? [{ customer: { taxId: { contains: taxId.trim() } } }] : []),
  //   ...(trank ? [{ customer: { rankId: { equals: trank } } }] : []),
  //   ...(status ? [{ customer: { status: { equals: status } } }] : []),
  //   ...(cityId ? [{ customer: { cityId: { equals: cityId } } }] : []),
  //   ...(districtId
  //     ? [{ customer: { districtId: { equals: districtId } } }]
  //     : []),
  //   ...(wardId ? [{ customer: { wardId: { equals: wardId } } }] : []),
  // ];

  const conditions = [
    ...(id ? [{ id: { contains: id } }] : []),
    ...(storeName ? [{ storeName: { contains: storeName } }] : []),
    ...(cccd ? [{ cccd: { contains: cccd } }] : []),
    ...(sapCustomerId ? [{ sapCustomerId: { contains: sapCustomerId } }] : []),
    ...(mainCustomer
      ? [
          {
            mainCustomer: {
              sapCustomerId: {
                contains: mainCustomer,
              },
            },
          },
        ]
      : []),
    ...(phone ? [{ phone: { contains: phone } }] : []),
    ...(taxId ? [{ taxId: { contains: taxId } }] : []),
    ...(trank ? [{ rankId: { contains: trank } }] : []),
    ...(status ? [{ status: { equals: status } }] : []),
    ...(cityId ? [{ cityId: { equals: cityId } }] : []),
    ...(wardId ? [{ wardId: { equals: wardId } }] : []),
    ...(districtId ? [{ districtId: { equals: districtId } }] : []),
    ...(cityNewId ? [{ cityNewId: { equals: cityNewId } }] : []),
    ...(wardNewId ? [{ wardNewId: { equals: wardNewId } }] : []),
  ];

  return {
    skip: (page - 1) * page_size,
    take: page_size,
    input: {
      // ...(plantId && { plantId: { equals: plantId } }),
      ...(plantId && {
        tcustomerPlants: {
          plantId: {
            equals: plantId,
          },
        },
      }),
      ...(conditions.length > 0 && { AND: conditions }),
    },
  };
};

export const VARIABLE_GET_ALL_CUSTOMER_RANK = {
  input: {
    OR: [
      {
        groupId: {
          equals: 'RK01-01',
        },
      },
      {
        groupId: {
          equals: 'RK01-02',
        },
      },
    ],
  },
};

export const VARIABLE_GET_STATUS_VIP_PRODUCT = {
  input: {
    groupId: {
      equals: 'RM02',
    },
  },
};

export const VARIABLE_GET_STATUS_VIP_PROCESS = {
  input: {
    groupId: {
      equals: 'RM01',
    },
  },
};

export const VARIABLES_STATUS_CUSTOMER = {
  input: {
    groupId: {
      equals: '100',
    },
  },
};

export const VARIABLE_UPDATE_LAT_LNG_CUSTOMER = (
  id: any,
  latLng: {
    lat: any;
    lng: any;
  },
) => {
  if (!latLng || id == undefined) return;
  return {
    input: {
      id,
      longitude: latLng.lng,
      latitude: latLng.lat,
    },
  };
};

export const VARIABLE_GET_CUSTOMER_COMBOBOX = ({
  value,
  pageSize,
}: IGetCustomerCb) => {
  return {
    skip: 0,
    take: pageSize,
    input: {
      ...(value && {
        OR: [
          {
            id: {
              contains: value,
            },
          },
          {
            storeName: {
              contains: value,
            },
          },
        ],
      }),
    },
  };
};

export const VARIABLE_UPDATE_CUSTOMER = (params: any) => {
  const {
    id,
    DanhXung,
    Gender,
    Surname,
    IDCusParent,
    address,
    birthday,
    cccd,
    city,
    cityNewId,
    coordinatesX,
    coordinatesY,
    district,
    email,
    nameCustomer,
    sdt,
    taxCode,
    typeCustomer,
    nameIndividualContact,
    ward,
    wardNewId,
    nameShort,
    urlImage1,
    urlImage2,
    urlImage3,
    urlImage4,
    urlImage5,
    note,
    name,
    passportId,
    terrorismType,
    terrorismUserApproval,
    terrorismUserDate,
    terrorismUserPlant,
  } = params;

  return {
    input: {
      id: id,
      mainCustomerId: IDCusParent || null,
      typeSap: typeCustomer === 'Cá nhân' ? '1' : '2',
      titleSap:
        DanhXung === 'Nam' ? '0002' : DanhXung === 'Nữ' ? '0001' : '0003',
      gender: Gender ? Gender : null,
      firstName: Surname?.trim(),
      shortName: nameShort?.trim(),
      storeName:
        typeCustomer === 'Cá nhân'
          ? Surname?.trim() + ' ' + name?.trim()
          : nameCustomer?.trim(),
      name: name?.trim(),
      note: note?.trim(),
      address: address
        ? address.trim().charAt(0).toUpperCase() + address.trim().slice(1)
        : address,
      dayofbirth: birthday,
      cccd: cccd?.trim(),
      passportId: passportId?.trim(),
      cityId: city,
      cityNewId: cityNewId || city,
      wardId: ward,
      wardNewId: wardNewId || ward,
      districtId: district || null,
      phone: sdt?.trim(),
      taxId: taxCode?.trim(),
      email: email?.trim(),
      latitude: coordinatesX,
      longitude: coordinatesY,
      urlImage1: urlImage1 || null,
      urlImage2: urlImage2 || null,
      urlImage3: urlImage3 || null,
      urlImage4: urlImage4 || null,
      urlImage5: urlImage5 || null,
      ...(terrorismType !== undefined && { terrorismType }),
      ...(terrorismUserApproval && { terrorismUserApproval }),
      ...(terrorismUserDate && { terrorismUserDate }),
      ...(terrorismUserPlant && { terrorismUserPlant }),
    },
  };
};

export const GET_CUSTOMERS_IN_COMBOBOX_VARIABLES = (params: {
  pageSize: number;
  searchValue?: string;
  plantId?: string;
}) => {
  const { plantId, pageSize, searchValue } = params;

  return {
    take: pageSize,
    skip: 0,
    input: {
      ...(plantId && {
        tcustomerPlants: {
          plantId: { equals: plantId },
        },
      }),
      approvalYn: { equals: true },
      OR: [
        { storeName: { contains: searchValue } },
        { id: { contains: searchValue } },
        { sapCustomerId: { contains: searchValue } },
        { taxId: { contains: searchValue } },
      ],
    },
  };
};

export const GET_CUSTOMERS_IN_COMBOBOX_MERGE_ORDER_VARIABLES = (params: {
  pageSize: number;
  searchValue?: string;
  plantId?: string;
}) => {
  const { pageSize, searchValue } = params;
  const trimmed = (searchValue || '').trim();
  const unpadded = trimmed.replace(/^0+/, '');
  const padded =
    trimmed.length > 0 && /^\d+$/.test(trimmed)
      ? trimmed.padStart(10, '0')
      : trimmed;

  const orConditions: Record<string, unknown>[] = [];
  if (trimmed) {
    orConditions.push(
      { storeName: { contains: trimmed } },
      { id: { contains: trimmed } },
      { sapCustomerId: { contains: trimmed } },
      { taxId: { contains: trimmed } },
    );
    if (unpadded && unpadded !== trimmed) {
      orConditions.push(
        { id: { contains: unpadded } },
        { sapCustomerId: { contains: unpadded } },
      );
    }
    if (padded && padded !== trimmed) {
      orConditions.push(
        { id: { contains: padded } },
        { sapCustomerId: { contains: padded } },
      );
    }
  }

  return {
    take: pageSize,
    skip: 0,
    input: {
      ...(orConditions.length > 0 && {
        OR: orConditions,
      }),
    },
  };
};
